$(document).ready(function(){
    if($(".guestCheckoutNewsLetterPopin").hasClass('guest') == true
        && $('.modal-body.newsletter-popup').children().length > 0){
        manageScroll();
        displayGuestCheckoutNewsletterPopup();
    }
    else if(showNewsletterPopup=="true" && $('.modal-body.newsletter-popup').children().length > 0){
        manageScroll();
        setTimeout(function(){
            displayNewsletterPopup();
        },15000);
    }
});

function displayGuestCheckoutNewsletterPopup() {
    trackDisplayNewsletter("Popin guest checkout");
    const modal = $('.guestCheckoutNewsLetterPopin');
    $('.newsletter-popup-fields input[name=newsletterContext]').val("gc");
    modal.modal().on("shown",function(){
        var s_height=document.querySelector(".modal-body.newsletter-popup").scrollHeight;
        $(".newsletter-popup-image").css("height",s_height)
        });
    $('.newsletter-popup-fields #checkbox-error').hide();
    $('.newsletter-popup-fields #email-error').hide();
}

function displayNewsletterPopup () {
    if(!$('.modal.in').is(':visible')) {
        $.ajax({
            type: "GET",
            contentType: "application/json",
            url: "/newsletter/popup/display",
            dataType: 'html'
        }).done(function (data) {
            trackDisplayNewsletter("Popin first visit");
            const modal = $('#NewsletterModal');
            $('.newsletter-popup-fields input[name=newsletterContext]').val("fv");
            modal.modal().on("shown",function(){
                var s_height=document.querySelector(".modal-body.newsletter-popup").scrollHeight;
                $(".newsletter-popup-image").css("height",s_height);
                $(".newsletter-popup-image").addClass("resp");
                });
            $('.newsletter-popup-fields #checkbox-error').hide();
            $('.newsletter-popup-fields #email-error').hide();
        });
    }
}

function submitNewsLetterPopupForm(form) {
    var $form =  $(form);

    var $inputFirstName = $form.find('.newsletter-popup-firstname input[type=text]').first();
    var $inputLastName = $form.find('.newsletter-popup-lastname input[type=text]').first();
    var $inputEmail = $form.find('.newsletter-popup-email input[type=email]').first();
    var $checkBoxCondition = $form.find('.newsletter-popup-checkbox input[type=checkbox]').first();
    var $recaptchaResponse = $form.find('input[name="g-recaptcha-response"]').first();
    var $newsletterContext = $form.find('input[name=newsletterContext]').first();
    var formData = {};
    formData['firstName'] = $inputFirstName.val();
    formData['lastName'] = $inputLastName.val();
    formData['email'] = $inputEmail.val();
    formData['condition'] = $checkBoxCondition.prop('checked');
    formData['newsletterContext']=$newsletterContext.val();
    formData['recaptcha']  = $recaptchaResponse.val();

    if (formData['email'] === "" || !validateEmail(formData['email'])) {
        $inputEmail.addClass('newsletter-popup-error');
        $form.find('.newsletter-popup-fields #email-error').show();
    }else{
        $inputEmail.removeClass('newsletter-popup-error');
        $form.find('.newsletter-popup-fields #email-error').hide();
    }
    if (!formData['condition']) {
        $form.find('.o-checkbox__container .checkmark').addClass('newsletter-popup-error') ;
        $form.find('.newsletter-popup-fields #checkbox-error').show();
    }else{
        $('#FormNewsLetterPopup .o-checkbox__container .checkmark').removeClass('newsletter-popup-error') ;
        $form.find('.newsletter-popup-fields #checkbox-error').hide();
    }
    jQuery.ajax({
        type: "POST",
        contentType: "application/json",
        url: $form.attr("action"),
        data: JSON.stringify(formData),
        dataType: 'html'
    }).done(function (data) {
        $(".newsletter-popup #globalMessages").html(data);
        if ( $(".newsletter-popup #globalMessages > .information_message").hasClass("positive")) {
            if (newsletterTrackingContext[formData['newsletterContext']]) {
                trackNewsletterSubscription(newsletterTrackingContext[formData['newsletterContext']]);
            }
            setTimeout(function(){
              $('#NewsletterModal').modal("toggle");
            }, 2000);
        }
    }).fail( function () {
        $(".newsletter-popup-content #globalMessages").html(errorLogin);
    });

}

function validateEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function manageScroll() {
    var element = document.querySelector('#NewsletterModal');
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
                var target_style = mutation.target.style.display;
                if (target_style === "block") {
                    if ($.fn.fullpage && $.fn.fullpage.setMouseWheelScrolling) $.fn.fullpage.setMouseWheelScrolling(false);
                    else document.body.style.overflow = "hidden";
                } else {
                    if ($.fn.fullpage && $.fn.fullpage.setMouseWheelScrolling) $.fn.fullpage.setMouseWheelScrolling(true);
                    else document.body.style.overflow = "auto";
                }
            }
        });
    });
    observer.observe(element, {
        attributes: true, childList: false
    });
}
